import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule],
  templateUrl: './app-input.component.html',
  styleUrls: ['./app-input.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AppInputComponent),
    multi: true
  }]
})
export class AppInputComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() name: string = '';
  @Input() id: string = '';
  @Input() icon: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() multiline: boolean = false;
  @Input() maxlength: string | number | null = null;
  @Input() readonly: boolean = false;

  @Output() changeEvent = new EventEmitter<any>();
  @Output() focusEvent = new EventEmitter<any>();
  @Output() blurEvent = new EventEmitter<any>();
  @Output() iconClick = new EventEmitter<any>();

  innerValue: any = '';
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  get value(): any { return this.innerValue; }
  set value(val: any) {
    this.innerValue = val;
    this.onChange(val);
    this.onTouched();
  }

  writeValue(value: any): void {
    this.innerValue = value;
  }
  registerOnChange(fn: (value: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void { this.disabled = isDisabled; }

  onInput(event: any): void {
    this.value = event?.target?.value ?? event;
  }

  onChangeEmit(event: any): void {
    this.changeEvent.emit(this.value);
  }

  onFocusEmit(event: any): void {
    this.focusEvent.emit(event);
  }

  onBlurEmit(event: any): void {
    this.blurEvent.emit(event);
  }

  onIconClick(event: any): void {
    this.iconClick.emit(event);
  }
}